import { useState, useEffect } from 'react';
import './Admin.css';

function GuestControl() {
  const [guestActive, setGuestActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchGuestStatus();
  }, []);

  const fetchGuestStatus = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/guest-status`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setGuestActive(data.isActive);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching guest status:', err);
      setLoading(false);
    }
  };

  const toggleGuest = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/toggle-guest`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setGuestActive(data.isActive);
      alert(data.message);
    } catch (err) {
      console.error('Error toggling guest:', err);
      alert('Error toggling guest access');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-container">
      <h1>Admin Settings</h1>
      
      <section className="admin-section">
        <h2>Guest Access Control</h2>
        <div className="guest-control">
          <p>Guest account is currently: <strong>{guestActive ? 'ENABLED' : 'DISABLED'}</strong></p>
          <button onClick={toggleGuest} className={guestActive ? 'btn-disable' : 'btn-enable'}>
            {guestActive ? 'Disable Guest' : 'Enable Guest'}
          </button>
        </div>
      </section>
    </div>
  );
}

export default GuestControl;